__turbopack_context__.v({
  "countryCode": "CustomDropdownGlobal-module-scss-module__57NViW__countryCode",
  "darkBg": "CustomDropdownGlobal-module-scss-module__57NViW__darkBg",
  "darkMode": "CustomDropdownGlobal-module-scss-module__57NViW__darkMode",
  "darkText": "CustomDropdownGlobal-module-scss-module__57NViW__darkText",
  "darkspecific": "CustomDropdownGlobal-module-scss-module__57NViW__darkspecific",
  "disabled": "CustomDropdownGlobal-module-scss-module__57NViW__disabled",
  "dropdown": "CustomDropdownGlobal-module-scss-module__57NViW__dropdown",
  "dropdownItem": "CustomDropdownGlobal-module-scss-module__57NViW__dropdownItem",
  "dropdownMenu": "CustomDropdownGlobal-module-scss-module__57NViW__dropdownMenu",
  "dropdownMenuWrapper": "CustomDropdownGlobal-module-scss-module__57NViW__dropdownMenuWrapper",
  "dropdownToggle": "CustomDropdownGlobal-module-scss-module__57NViW__dropdownToggle",
  "liContainer": "CustomDropdownGlobal-module-scss-module__57NViW__liContainer",
  "scrollArrow": "CustomDropdownGlobal-module-scss-module__57NViW__scrollArrow",
  "spanWidth": "CustomDropdownGlobal-module-scss-module__57NViW__spanWidth",
});
